// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1xgTl","left":"InfoRow_left__3eK7b"};